import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import { styles } from './formStyles';

const BetsBadge = ({ t, highestBetValue, }) => {
  const classes = useStyles();
  return (
    <div className={classes.noBets}>
      <i className="material-icons header-menu-icon betting_icon">group</i>
      <span>{t('highest_offer')} <strong> {highestBetValue} &euro; </strong> </span>
    </div>
  );
};

BetsBadge.propTypes = {
  t: PropTypes.func.isRequired,
  highestBetValue: PropTypes.number.isRequired,
};

const useStyles = createUseStyles({
  noBets: {
    backgroundColor: '#FFF7EB',
    border: `1px solid ${styles.colors.orange}`,
    borderRadius: '4px',
    display: 'flex',
    padding: '0.8em',
    fontSize: '14px',
    alignItems: 'center',
    '& i': {
      color: styles.colors.orange,
      marginRight: '0.3em',
    },
    '& span': {
      color: styles.colors.dark,
    },
  },
});

export default BetsBadge;
